<template>
  <svg
    v-bind="$attrs"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.52925 1.52864C1.7896 1.26829 2.21171 1.26829 2.47206 1.52864L10.3053 9.36189C10.338 9.38886 10.3677 9.41869 10.3943 9.45087L14.4721 13.5286C14.7324 13.789 14.7324 14.2111 14.4721 14.4714C14.2117 14.7318 13.7896 14.7318 13.5292 14.4714L10.1402 11.0824L9.95818 11.5675C9.92476 11.6566 9.87267 11.7375 9.80539 11.8048L8.80539 12.8048C8.54504 13.0651 8.12293 13.0651 7.86258 12.8048L6.00065 10.9428L3.47206 13.4714C3.21171 13.7318 2.7896 13.7318 2.52925 13.4714C2.2689 13.2111 2.2689 12.789 2.52925 12.5286L5.05784 10L3.19591 8.13811C2.93556 7.87776 2.93556 7.45565 3.19591 7.1953L4.19591 6.1953C4.2632 6.12802 4.34411 6.07592 4.4332 6.0425L4.91834 5.86054L1.52925 2.47145C1.2689 2.2111 1.2689 1.78899 1.52925 1.52864ZM5.95396 6.89616L5.03662 7.24021L4.61013 7.66671L8.33398 11.3906L8.76049 10.9641L9.10458 10.0468L5.95396 6.89616ZM9.19591 2.1953C9.45626 1.93495 9.87837 1.93495 10.1387 2.1953L13.4716 5.52821C13.4715 5.52809 13.4717 5.52833 13.4716 5.52821C13.4718 5.52838 13.4723 5.5289 13.4725 5.52906L13.8054 5.86197C14.0657 6.12232 14.0657 6.54443 13.8054 6.80478C13.5931 7.01706 13.2733 7.05625 13.0213 6.92235L11.3055 8.63871C11.0452 8.8991 10.623 8.89916 10.3627 8.63885C10.1023 8.37854 10.1022 7.95643 10.3625 7.69604L12.0579 6.00011L10.0006 3.94285L8.30605 5.63744C8.04571 5.89779 7.6236 5.89779 7.36325 5.63744C7.1029 5.3771 7.1029 4.95499 7.36325 4.69464L9.07838 2.9795C8.94443 2.72749 8.9836 2.40761 9.19591 2.1953Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>
